import { apiClient } from '@isocel/front-common';

import { GetAllPackagingFlowParams, Package, PackagingFlow, PaginateResult } from './types';
// Removed useAuth hook from the top level. Pass user as a parameter where needed.

export const fetchPackagingFlowByLoadingSession = async (loadingSessionId: string): Promise<PackagingFlow> => {
    const { data } = await apiClient().get(`/packagingFlow/byLoadingSession/${loadingSessionId}`);
    return data;
};

export const fetchPackagingFlowByVoucher = async (voucher: string): Promise<PackagingFlow> => {
    const { data } = await apiClient().get(`/packagingFlow/byVoucher/${voucher}`);
    return data;
};
export const createPackagingFlow = async (payload: any, files?: File[]): Promise<PackagingFlow> => {
    const formData = new FormData();
    if (files) {
        files.forEach((file) => {
            formData.append(`file`, file);
        });
    }
    formData.append('data', JSON.stringify(payload));

    const { data } = await apiClient().post(`/packagingFlow/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
};

export const updatePackagingFlow = async (id: string, payload: any, files?: File[]): Promise<PackagingFlow> => {
    const formData = new FormData();
    if (files) {
        files.forEach((file) => {
            formData.append(`file`, file);
        });
    }
    formData.append('data', JSON.stringify(payload));

    const { data } = await apiClient().put(`/packagingFlow/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
};
export const updatePackageItemStatus = async (
    packageFlowId: string,
    packageItemId: string,
    accept?: boolean
): Promise<Package> => {
    const data: Package = await apiClient().put(
        `/packageItemStatus/${packageFlowId}/package/${packageItemId}`,
        accept !== undefined ? { accept } : {}
    );
    return data;
};

export const downloadPackagingVoucher = async (voucherNumber: string) => {
    return await apiClient().get(`/packagingVoucher/${voucherNumber}/download`, {
        responseType: 'blob', // Important to handle binary data
    });
};

export const downloadFile = async (fileId: string): Promise<{ data: Blob; headers: any }> => {
    const response = await apiClient().get(`/documents/testGetFile/${fileId}`, {
        responseType: 'blob', // Important to handle binary data
    });
    return {
        data: response.data,
        headers: response.headers,
    };
};

export const downloadCsv = async (params: GetAllPackagingFlowParams): Promise<PaginateResult<PackagingFlow>> => {
    const response = await apiClient().get('/packagingFlows/downloadCsv', {
        params: {
            pageSize: params.pageSize,
            page: params.page,
            differenceReported: params.differenceReported,
            packageIds: params.packageIds?.join(','),
            status: params.status?.join(','),
            storeIds: Array.isArray(params.storeIds) ? params.storeIds.join(',') : params.storeIds,
            supplierIds: params.supplierIds?.join(','),
            parcPalettIds: params.parcPalettIds?.join(','),
            warehouseIds: params.warehouseIds?.join(','),
            transportVoucher: params.transportVoucher,
            bonDeTransport: params.bonDeTransport?.join(','),
            flowType: params.flowType,
            sort: params.sortField,
            sortOrder: params.sortOrder,
            isMounted: params.isMounted,
            startDate: params.startDate,
            endDate: params.endDate,
            organization: params.organization,
            litigeStatus: params.litigeStatus?.join(','),
            invoiceName: params.invoiceName || undefined,
        },
    });
    return response.data;
};

export const getAllPackagingFlow = async (
    params?: GetAllPackagingFlowParams,
    user?: { organization: { id: string } }
): Promise<PaginateResult<PackagingFlow>> => {
    const response = await apiClient().get('/packagingFlows', {
        params: params
            ? {
                  pageSize: params.pageSize,
                  page: params.page,
                  differenceReported: params.differenceReported,
                  packageIds: params.packageIds?.join(','),
                  status: params.status?.join(','),
                  voucherStatus: params.voucherStatus?.join(','),
                  storeIds: Array.isArray(params.storeIds) ? params.storeIds.join(',') : params.storeIds,
                  supplierIds: params.supplierIds?.join(','),
                  parcPalettIds: params.parcPalettIds?.join(','),
                  warehouseIds: params.warehouseIds?.join(','),
                  transportVoucher: params.transportVoucher,
                  bonDeTransport: params.bonDeTransport?.join(','),
                  flowType: params.flowType,
                  sort: params.sortField,
                  sortOrder: params.sortOrder,
                  isMounted: params.isMounted,
                  startDate: params.startDate,
                  endDate: params.endDate,
                  organization: user?.organization.id,
                  litigeStatus: params.litigeStatus?.join(','),
                  invoiceName: params.invoiceName || undefined,
                  received: params.received,
              }
            : undefined,
    });

    return response.data;
};

export const getPackingFlowFromStore = async (storeId: string, voucher: string): Promise<PackagingFlow> => {
    const { data } = await apiClient().get(`/getPackingFlowFromStore/${storeId}/${voucher}`);
    return data;
};

export const getPackingFlowFromVoucher = async (voucher: string): Promise<PackagingFlow> => {
    const { data } = await apiClient().get(`/packagingFlows/voucher/${voucher}`);
    return data;
};
export const getVoucherNumberDetails = async (
    flowId: string,
    organization: string,
    isVoucher: boolean
): Promise<any> => {
    const { data } = await apiClient().get(`/packagingVoucher/${flowId}/${organization}/${isVoucher.toString()}`);
    return data;
};

export const validateTransportVoucher = async (voucher: string, flowType: number, storeId: string): Promise<any> => {
    const { data } = await apiClient().get(`/validate-transport-voucher/${voucher}/${flowType}/${storeId}`);
    return data;
};
export const getPackagingFlowByPackagingVoucher = async (voucherId: string[]) => {
    const { data } = await apiClient().get(`/packagingFlow/byPackagingVoucher/${voucherId.join(',')}`);
    return data;
};

export const uploadFile = async (files?: FormData): Promise<any> => {
    const { data } = await apiClient().post(`/documents/testSendFile`, files, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
};
